import { groupNames } from "../From/utils";
import { defaultViewPreset } from "../../../../utils/constants";

export const defaultFields = {
  taskGridWidth: 60,
  indicatorEarlyDates: false,
  indicatorConstraintDate: false,
  indicatorLateDates: false,
  indicatorDeadlineDate: false,
  zoomToFitOnLoad: false,
  autoSave: false,
  hideWeekends: false,
};

export const localDefaultFields = {
  [groupNames.SINGLE_PROJECT_GANTT_CONFIG]: {
    showHistogram: false,
    viewPreset: defaultViewPreset,
    autoSave: false,
  },
  [groupNames.DEPARTMENT_GANTT_CONFIG]: {
    showGantt: true,
    showScheduler: true,
    showHistogram: true,
    showUtilization: false,
    viewPreset: defaultViewPreset,
    autoSave: false,
  },
  [groupNames.MULTI_PROJECT_GANTT_CONFIG]: {
    taskGridWidth: 48,
    showHistogram: false,
    showTreeStructure: false,
    viewPreset: defaultViewPreset,
  },
};
